// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate, Link } from 'react-router-dom';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import {
//   faFileAlt,
//   faUser,
//   faEnvelope,
//   faPhone,
//   faMapMarkerAlt,
//   faStar,
//   faGraduationCap,
//   faBriefcase,
//   faClipboardList,
//   faChevronLeft,
//   faSpinner,
//   faExclamationTriangle,
//   faIdBadge,
//   faTools,
//   faHistory,
//   faBuilding,
//   faClock,
//   faPercentage,
//   faLightbulb,
//   faCalendarAlt,
// } from '@fortawesome/free-solid-svg-icons';
// import { backend_url } from '../config';
// import '../CandidateProfile.css';

// // Stage colors consistent with SavedCandidates
// const stageColors = {
//   'Not Started': 'var(--coreops-status-grey, #adb5bd)',
//   'Resume Screening': 'var(--coreops-status-light-blue, #a9def9)',
//   'Phone Interview': 'var(--coreops-status-sky-blue, #72d5fd)',
//   'Technical Assessment': 'var(--coreops-status-teal, #2ab7ca)',
//   'On-site Interview': 'var(--coreops-secondary, #00A4CC)',
//   'Reference Check': 'var(--coreops-status-dark-blue, #0077b6)',
//   'Offer Extended': 'var(--coreops-status-greenish-teal, #2a9d8f)',
//   Hired: 'var(--coreops-success-text, #28a745)',
//   Rejected: 'var(--coreops-error-text, #d9534f)',
//   'On Hold': 'var(--coreops-status-yellow, #fdc500)',
// };

// function CandidateProfile() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const [candidate, setCandidate] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     fetchCandidateProfile();
//   }, [id]);

//   const fetchCandidateProfile = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const baseEndpoint = 'candidates';
//       const response = await fetch(`${backend_url}/${baseEndpoint}/${id}`);

//       if (!response.ok) {
//         const errorData = await response.json().catch(() => ({}));
//         throw new Error(
//           errorData.message || `Failed to fetch candidate: ${response.status}`
//         );
//       }

//       const data = await response.json();
//       const candidateData = data.candidate || data;

//       // DEBUG: Log the actual data structure
//       console.log(
//         '🔍 DEBUG - Full candidate data structure:',
//         JSON.stringify(candidateData, null, 2)
//       );
//       console.log(
//         '🔍 DEBUG - Companies worked:',
//         candidateData.companiesWorked
//       );
//       console.log('🔍 DEBUG - Education:', candidateData.education);
//       console.log('🔍 DEBUG - Analysis object:', candidateData.analysis);

//       setCandidate(candidateData);
//     } catch (err) {
//       console.error('Error fetching candidate profile:', err);
//       setError(
//         err.message || 'Failed to load candidate profile. Please try again.'
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Enhanced helper to safely access nested properties
//   const getAnalysisData = (key, defaultValue = 'N/A') => {
//     if (!candidate) return defaultValue;

//     // Check multiple possible locations for the data
//     const possibleLocations = [
//       candidate.analysis?.[key],
//       candidate[key],
//       candidate.resumeAnalysis?.[key],
//       candidate.data?.[key],
//     ];

//     for (let location of possibleLocations) {
//       if (location !== undefined && location !== null && location !== 'N/A') {
//         console.log(`🔍 DEBUG - Found ${key} at location:`, location);
//         return location;
//       }
//     }

//     console.log(
//       `⚠️ DEBUG - Could not find ${key}, using default:`,
//       defaultValue
//     );
//     return defaultValue;
//   };

//   if (loading) {
//     return (
//       <div className='coreops-page-container candidate-profile-page'>
//         <div className='coreops-content-wrapper'>
//           <div className='coreops-message-container loading'>
//             <FontAwesomeIcon icon={faSpinner} spin size='3x' />
//             <p>Loading Candidate Profile...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className='coreops-page-container candidate-profile-page'>
//         <div className='coreops-content-wrapper'>
//           <div className='coreops-message-container error'>
//             <FontAwesomeIcon icon={faExclamationTriangle} size='3x' />
//             <p className='error-title'>Error Loading Profile</p>
//             <p>{error}</p>
//             <button
//               onClick={fetchCandidateProfile}
//               className='coreops-button coreops-button-primary'
//             >
//               Try Again
//             </button>
//             <Link
//               to={'/candidates'}
//               className='coreops-button coreops-button-secondary'
//               style={{ marginLeft: '10px' }}
//             >
//               <FontAwesomeIcon icon={faChevronLeft} /> Back to List
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   if (!candidate) {
//     return (
//       <div className='coreops-page-container candidate-profile-page'>
//         <div className='coreops-content-wrapper'>
//           <div className='coreops-message-container empty'>
//             <FontAwesomeIcon icon={faUser} size='4x' />
//             <p className='empty-title'>Candidate Not Found</p>
//             <p className='empty-subtitle'>
//               The requested candidate profile could not be located.
//             </p>
//             <Link
//               to={'/candidates'}
//               className='coreops-button coreops-button-primary'
//             >
//               <FontAwesomeIcon icon={faChevronLeft} /> Back to Candidate List
//             </Link>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Extract data using the enhanced helper
//   const candidateName = getAnalysisData('name');
//   const candidateEmail = getAnalysisData('email');
//   const candidatePhone = getAnalysisData('phone', null);
//   const candidateLocation = getAnalysisData('location', null);
//   const similarityScore = getAnalysisData('similarityScore', 0);
//   const resumeSummary = getAnalysisData(
//     'resumeSummary',
//     'No summary available.'
//   );
//   const keySkills = getAnalysisData('keySkills', []);
//   const totalExperienceYears = getAnalysisData('totalExperienceYears', 'N/A');
//   const companiesWorked = getAnalysisData('companiesWorked', []);
//   const educationList = getAnalysisData('education', []);
//   const interviewStatus = candidate.interviewStatus || 'Not Started';

//   // DEBUG: Log extracted values
//   console.log('🔍 DEBUG - Extracted companies:', companiesWorked);
//   console.log('🔍 DEBUG - Extracted education:', educationList);

//   return (
//     <div className='coreops-page-container candidate-profile-page'>
//       <div className='coreops-content-wrapper'>
//         <div className='coreops-profile-header'>
//           <Link to={'/candidates'} className='coreops-back-link'>
//             <FontAwesomeIcon icon={faChevronLeft} /> Back to Candidate List
//           </Link>
//         </div>

//         <div className='coreops-profile-layout'>
//           {/* Sidebar */}
//           <aside className='coreops-profile-sidebar'>
//             <div className='coreops-profile-avatar-container'>
//               <FontAwesomeIcon
//                 icon={faIdBadge}
//                 className='coreops-profile-avatar-icon'
//               />
//             </div>
//             <h2 className='coreops-candidate-name'>{candidateName}</h2>
//             <div className='coreops-candidate-status'>
//               <span
//                 className='coreops-status-pill large'
//                 style={{ backgroundColor: stageColors[interviewStatus] }}
//               >
//                 {interviewStatus}
//               </span>
//             </div>

//             <div className='coreops-contact-info'>
//               <div className='coreops-info-item'>
//                 <FontAwesomeIcon
//                   icon={faEnvelope}
//                   className='coreops-info-icon'
//                 />
//                 <a
//                   href={`mailto:${candidateEmail}`}
//                   title={`Email ${candidateName}`}
//                 >
//                   {candidateEmail}
//                 </a>
//               </div>
//               {candidatePhone && candidatePhone !== 'N/A' && (
//                 <div className='coreops-info-item'>
//                   <FontAwesomeIcon
//                     icon={faPhone}
//                     className='coreops-info-icon'
//                   />
//                   <span>{candidatePhone}</span>
//                 </div>
//               )}
//               {candidateLocation && candidateLocation !== 'N/A' && (
//                 <div className='coreops-info-item'>
//                   <FontAwesomeIcon
//                     icon={faMapMarkerAlt}
//                     className='coreops-info-icon'
//                   />
//                   <span>{candidateLocation}</span>
//                 </div>
//               )}
//             </div>

//             <div className='coreops-score-card'>
//               <div className='score-value'>{similarityScore}%</div>
//               <div className='score-label'>Match Score</div>
//               <FontAwesomeIcon icon={faStar} className='score-icon-bg' />
//             </div>
//           </aside>

//           {/* Main Content */}
//           <main className='coreops-profile-main-content'>
//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faLightbulb} /> AI Resume Summary
//               </h3>
//               <p className='coreops-summary-text'>{resumeSummary}</p>
//             </section>

//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faTools} /> Key Skills
//               </h3>
//               {keySkills && Array.isArray(keySkills) && keySkills.length > 0 ? (
//                 <div className='coreops-skills-list'>
//                   {keySkills.map((skill, index) => (
//                     <span key={index} className='coreops-skill-tag'>
//                       {skill}
//                     </span>
//                   ))}
//                 </div>
//               ) : (
//                 <div>
//                   <p className='coreops-no-data-text'>
//                     No key skills extracted.
//                   </p>
//                   <p style={{ fontSize: '12px', color: '#666' }}>
//                     DEBUG: keySkills value = {JSON.stringify(keySkills)}
//                   </p>
//                 </div>
//               )}
//             </section>

//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faHistory} /> Professional Experience
//               </h3>
//               <p className='coreops-experience-total'>
//                 Total Estimated Experience:{' '}
//                 <strong>
//                   {totalExperienceYears}{' '}
//                   {totalExperienceYears === 1 ? 'year' : 'years'}
//                 </strong>
//               </p>
//               {companiesWorked &&
//               Array.isArray(companiesWorked) &&
//               companiesWorked.length > 0 ? (
//                 <div className='coreops-experience-list'>
//                   {companiesWorked.map((exp, index) => (
//                     <div key={index} className='coreops-experience-item'>
//                       <div className='coreops-item-header'>
//                         <FontAwesomeIcon
//                           icon={faBuilding}
//                           className='coreops-item-icon'
//                         />
//                         <span className='coreops-item-main-title'>
//                           {exp.companyName || 'N/A'}
//                         </span>
//                       </div>
//                       <div className='coreops-item-details'>
//                         <p className='coreops-item-subtitle'>
//                           {exp.role || 'N/A'}
//                         </p>
//                         {exp.duration && exp.duration !== 'N/A' && (
//                           <p className='coreops-item-meta'>
//                             <FontAwesomeIcon icon={faClock} /> {exp.duration}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div>
//                   <p className='coreops-no-data-text'>
//                     No professional experience listed or extracted.
//                   </p>
//                   <p style={{ fontSize: '12px', color: '#666' }}>
//                     DEBUG: companiesWorked value ={' '}
//                     {JSON.stringify(companiesWorked)}
//                   </p>
//                 </div>
//               )}
//             </section>

//             <section className='coreops-profile-card'>
//               <h3 className='coreops-card-title'>
//                 <FontAwesomeIcon icon={faGraduationCap} /> Education
//               </h3>
//               {educationList &&
//               Array.isArray(educationList) &&
//               educationList.length > 0 ? (
//                 <div className='coreops-experience-list'>
//                   {educationList.map((edu, index) => (
//                     <div key={index} className='coreops-experience-item'>
//                       <div className='coreops-item-header'>
//                         <FontAwesomeIcon
//                           icon={faGraduationCap}
//                           className='coreops-item-icon'
//                         />
//                         <span className='coreops-item-main-title'>
//                           {edu.institution || 'N/A'}
//                         </span>
//                       </div>
//                       <div className='coreops-item-details'>
//                         <p className='coreops-item-subtitle'>
//                           {edu.degree || 'N/A'}
//                         </p>
//                         {edu.year && edu.year !== 'N/A' && (
//                           <p className='coreops-item-meta'>
//                             <FontAwesomeIcon icon={faCalendarAlt} /> {edu.year}
//                           </p>
//                         )}
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               ) : (
//                 <div>
//                   <p className='coreops-no-data-text'>
//                     No education details listed or extracted.
//                   </p>
//                   <p style={{ fontSize: '12px', color: '#666' }}>
//                     DEBUG: educationList value = {JSON.stringify(educationList)}
//                   </p>
//                 </div>
//               )}
//             </section>
//           </main>
//         </div>
//         <footer className='coreops-footer results-sub-footer'>
//           <p>
//             © {new Date().getFullYear()} CoreOps.ai - Candidate Profile View
//           </p>
//         </footer>
//       </div>
//     </div>
//   );
// }

// export default CandidateProfile;

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFileAlt,
  faUser,
  faEnvelope,
  faPhone,
  faMapMarkerAlt,
  faStar,
  faGraduationCap,
  faBriefcase,
  faClipboardList,
  faChevronLeft,
  faSpinner,
  faExclamationTriangle,
  faIdBadge,
  faTools,
  faHistory,
  faBuilding,
  faClock,
  faPercentage,
  faLightbulb,
  faCalendarAlt,
  faBan,
} from '@fortawesome/free-solid-svg-icons';
import { backend_url } from '../config';
import api from '../axiosInstance';
import RejectionModal from './RejectionModal';
import '../CandidateProfile.css';

// Stage colors consistent with SavedCandidates
const stageColors = {
  'Not Started': 'var(--coreops-status-grey, #adb5bd)',
  'Resume Screening': 'var(--coreops-status-light-blue, #a9def9)',
  'Phone Screening': 'var(--coreops-status-sky-blue, #72d5fd)',
  'Phone Interview': 'var(--coreops-status-sky-blue, #72d5fd)',
  '1st Technical Round': 'var(--coreops-status-teal, #2ab7ca)',
  '2nd Technical Round': 'var(--coreops-secondary, #00A4CC)',
  'Managerial Round': 'var(--coreops-status-dark-blue, #0077b6)',
  'HR Round': 'var(--coreops-status-greenish-teal, #2a9d8f)',
  'Technical Assessment': 'var(--coreops-status-teal, #2ab7ca)',
  'On-site Interview': 'var(--coreops-secondary, #00A4CC)',
  'Reference Check': 'var(--coreops-status-dark-blue, #0077b6)',
  'Offer Extended': 'var(--coreops-status-greenish-teal, #2a9d8f)',
  Hired: 'var(--coreops-success-text, #28a745)',
  Rejected: 'var(--coreops-error-text, #d9534f)',
  'On Hold': 'var(--coreops-status-yellow, #fdc500)',
};

const interviewStages = [
  'Not Started',
  'Resume Screening',
  'Phone Screening',
  'Phone Interview',
  '1st Technical Round',
  '2nd Technical Round',
  'Managerial Round',
  'HR Round',
  'Technical Assessment',
  'On-site Interview',
  'Reference Check',
  'Offer Extended',
  'Hired',
  'Rejected',
  'On Hold',
];

function CandidateProfile() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [candidate, setCandidate] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isQualifiedCandidate, setIsQualifiedCandidate] = useState(false);
  const [showRejectionModal, setShowRejectionModal] = useState(false);
  const [updatingStage, setUpdatingStage] = useState(false);

  const handleStageChange = async (newStage) => {
    if (newStage === 'Rejected') {
      setShowRejectionModal(true);
      return;
    }
    try {
      setUpdatingStage(true);
      const endpoint = isQualifiedCandidate
        ? `/qualified-candidates/${id}/interview-status`
        : `/candidates/${id}/interview-status`;

      const response = await api.put(endpoint, { interviewStatus: newStage });
      setCandidate(response.data.candidate || response.data);
    } catch (err) {
      console.error('Error updating stage:', err);
      alert('Failed to update stage: ' + (err.message || 'Server error'));
    } finally {
      setUpdatingStage(false);
    }
  };

  const handleRejectionSuccess = (updatedCandidate) => {
    setCandidate(updatedCandidate);
  };

  useEffect(() => {
    fetchCandidateProfile();
  }, [id]);

  const fetchCandidateProfile = async () => {
    try {
      setLoading(true);
      setError(null);

      // Check if we're coming from qualified candidates page
      const fromQualified =
        location.state?.fromQualified ||
        document.referrer.includes('/qualified-candidates');

      // Try qualified candidates endpoint first if coming from that page
      let response;
      let candidateData;

      if (fromQualified) {
        try {
          response = await api.get(`/qualified-candidates/${id}`);
          candidateData = response.data.candidate || response.data;
          setIsQualifiedCandidate(true);
        } catch (err) {
          console.log(
            'Failed to fetch from qualified-candidates, trying regular candidates...'
          );
        }
      }

      // If we didn't get data from qualified candidates, try regular candidates endpoint
      if (!candidateData) {
        response = await api.get(`/candidates/${id}`);
        candidateData = response.data.candidate || response.data;
        setIsQualifiedCandidate(false);
      }

      // DEBUG: Log the actual data structure
      console.log(
        '🔍 DEBUG - Full candidate data structure:',
        JSON.stringify(candidateData, null, 2)
      );
      console.log(
        '🔍 DEBUG - Companies worked:',
        candidateData.companiesWorked
      );
      console.log('🔍 DEBUG - Education:', candidateData.education);
      console.log('🔍 DEBUG - Analysis object:', candidateData.analysis);

      setCandidate(candidateData);
    } catch (err) {
      console.error('Error fetching candidate profile:', err);
      setError(
        err.message || 'Failed to load candidate profile. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  // Enhanced helper to safely access nested properties
  const getAnalysisData = (key, defaultValue = 'N/A') => {
    if (!candidate) return defaultValue;

    // Check multiple possible locations for the data
    const possibleLocations = [
      candidate.analysis?.[key],
      candidate[key],
      candidate.resumeAnalysis?.[key],
      candidate.data?.[key],
    ];

    for (let location of possibleLocations) {
      if (location !== undefined && location !== null && location !== 'N/A') {
        console.log(`🔍 DEBUG - Found ${key} at location:`, location);
        return location;
      }
    }

    console.log(
      `⚠️ DEBUG - Could not find ${key}, using default:`,
      defaultValue
    );
    return defaultValue;
  };

  // Determine the back link based on where we came from
  const getBackLink = () => {
    if (isQualifiedCandidate || location.state?.fromQualified) {
      return '/qualified-candidates';
    }
    return '/candidates';
  };

  const getBackLinkText = () => {
    if (isQualifiedCandidate || location.state?.fromQualified) {
      return 'Back to Qualified Candidates';
    }
    return 'Back to Candidate List';
  };

  if (loading) {
    return (
      <div className='coreops-page-container candidate-profile-page'>
        <div className='coreops-content-wrapper'>
          <div className='coreops-message-container loading'>
            <FontAwesomeIcon icon={faSpinner} spin size='3x' />
            <p>Loading Candidate Profile...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className='coreops-page-container candidate-profile-page'>
        <div className='coreops-content-wrapper'>
          <div className='coreops-message-container error'>
            <FontAwesomeIcon icon={faExclamationTriangle} size='3x' />
            <p className='error-title'>Error Loading Profile</p>
            <p>{error}</p>
            <button
              onClick={fetchCandidateProfile}
              className='coreops-button coreops-button-primary'
            >
              Try Again
            </button>
            <Link
              to={getBackLink()}
              className='coreops-button coreops-button-secondary'
              style={{ marginLeft: '10px' }}
            >
              <FontAwesomeIcon icon={faChevronLeft} /> {getBackLinkText()}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  if (!candidate) {
    return (
      <div className='coreops-page-container candidate-profile-page'>
        <div className='coreops-content-wrapper'>
          <div className='coreops-message-container empty'>
            <FontAwesomeIcon icon={faUser} size='4x' />
            <p className='empty-title'>Candidate Not Found</p>
            <p className='empty-subtitle'>
              The requested candidate profile could not be located.
            </p>
            <Link
              to={getBackLink()}
              className='coreops-button coreops-button-primary'
            >
              <FontAwesomeIcon icon={faChevronLeft} /> {getBackLinkText()}
            </Link>
          </div>
        </div>
      </div>
    );
  }

  // Extract data using the enhanced helper
  const candidateName = getAnalysisData('name');
  const candidateEmail = getAnalysisData('email');
  const candidatePhone = getAnalysisData('phone', null);
  const candidateLocation = getAnalysisData('location', null);
  const similarityScore = getAnalysisData('similarityScore', 0);
  const resumeSummary = getAnalysisData(
    'resumeSummary',
    'No summary available.'
  );
  const keySkills = getAnalysisData('keySkills', []);
  const totalExperienceYears = getAnalysisData('totalExperienceYears', 'N/A');
  const companiesWorked = getAnalysisData('companiesWorked', []);
  const educationList = getAnalysisData('education', []);
  const interviewStatus = candidate.interviewStatus || 'Not Started';

  // DEBUG: Log extracted values
  console.log('🔍 DEBUG - Extracted companies:', companiesWorked);
  console.log('🔍 DEBUG - Extracted education:', educationList);

  return (
    <div className='coreops-page-container candidate-profile-page'>
      <div className='coreops-content-wrapper'>
        <div className='coreops-profile-header'>
          <Link to={getBackLink()} className='coreops-back-link'>
            <FontAwesomeIcon icon={faChevronLeft} /> {getBackLinkText()}
          </Link>
          {isQualifiedCandidate && (
            <div className='qualified-badge'>
              <span className='badge-text'>✓ Qualified Candidate</span>
            </div>
          )}
        </div>

        <div className='coreops-profile-layout'>
          {/* Sidebar */}
          <aside className='coreops-profile-sidebar'>
            <div className='coreops-profile-avatar-container'>
              <FontAwesomeIcon
                icon={faIdBadge}
                className='coreops-profile-avatar-icon'
              />
            </div>
            <h2 className='coreops-candidate-name'>{candidateName}</h2>
            <div className='coreops-candidate-status'>
              <span
                className='coreops-status-pill large'
                style={{ backgroundColor: stageColors[interviewStatus] }}
              >
                {interviewStatus}
              </span>
            </div>

            <div className='coreops-contact-info'>
              <div className='coreops-info-item'>
                <FontAwesomeIcon
                  icon={faEnvelope}
                  className='coreops-info-icon'
                />
                <a
                  href={`mailto:${candidateEmail}`}
                  title={`Email ${candidateName}`}
                >
                  {candidateEmail}
                </a>
              </div>
              {candidatePhone && candidatePhone !== 'N/A' && (
                <div className='coreops-info-item'>
                  <FontAwesomeIcon
                    icon={faPhone}
                    className='coreops-info-icon'
                  />
                  <span>{candidatePhone}</span>
                </div>
              )}
              {candidateLocation && candidateLocation !== 'N/A' && (
                <div className='coreops-info-item'>
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className='coreops-info-icon'
                  />
                  <span>{candidateLocation}</span>
                </div>
              )}
            </div>

            <div className='coreops-score-card'>
              <div className='score-value'>{similarityScore}%</div>
              <div className='score-label'>Match Score</div>
              <FontAwesomeIcon icon={faStar} className='score-icon-bg' />
            </div>

            {/* Stage Update & Rejection Actions */}
            <div style={{ marginTop: '20px', padding: '16px', backgroundColor: '#ffffff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid #eee' }}>
              <h4 style={{ margin: '0 0 12px 0', fontSize: '14px', color: '#333' }}>Interview Stage Actions</h4>
              
              <div style={{ marginBottom: '12px' }}>
                <label style={{ fontSize: '12px', fontWeight: '600', color: '#666', display: 'block', marginBottom: '4px' }}>Move Candidate to Round:</label>
                <select
                  value={interviewStatus}
                  onChange={(e) => handleStageChange(e.target.value)}
                  disabled={updatingStage}
                  style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '13px' }}
                >
                  {interviewStages.map((stg) => (
                    <option key={stg} value={stg}>{stg}</option>
                  ))}
                </select>
              </div>

              {interviewStatus !== 'Rejected' && (
                <button
                  onClick={() => setShowRejectionModal(true)}
                  style={{
                    width: '100%',
                    padding: '8px 12px',
                    backgroundColor: '#d9534f',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '4px',
                    fontWeight: '600',
                    fontSize: '13px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '6px'
                  }}
                >
                  <FontAwesomeIcon icon={faBan} /> Reject Candidate
                </button>
              )}
            </div>
          </aside>

          {/* Main Content */}
          <main className='coreops-profile-main-content'>
            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faLightbulb} /> AI Resume Summary
              </h3>
              <p className='coreops-summary-text'>{resumeSummary}</p>
            </section>

            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faTools} /> Key Skills
              </h3>
              {keySkills && Array.isArray(keySkills) && keySkills.length > 0 ? (
                <div className='coreops-skills-list'>
                  {keySkills.map((skill, index) => (
                    <span key={index} className='coreops-skill-tag'>
                      {skill}
                    </span>
                  ))}
                </div>
              ) : (
                <div>
                  <p className='coreops-no-data-text'>
                    No key skills extracted.
                  </p>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    DEBUG: keySkills value = {JSON.stringify(keySkills)}
                  </p>
                </div>
              )}
            </section>

            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faHistory} /> Professional Experience
              </h3>
              <p className='coreops-experience-total'>
                Total Estimated Experience:{' '}
                <strong>
                  {totalExperienceYears}{' '}
                  {totalExperienceYears === 1 ? 'year' : 'years'}
                </strong>
              </p>
              {companiesWorked &&
              Array.isArray(companiesWorked) &&
              companiesWorked.length > 0 ? (
                <div className='coreops-experience-list'>
                  {companiesWorked.map((exp, index) => (
                    <div key={index} className='coreops-experience-item'>
                      <div className='coreops-item-header'>
                        <FontAwesomeIcon
                          icon={faBuilding}
                          className='coreops-item-icon'
                        />
                        <span className='coreops-item-main-title'>
                          {exp.companyName || 'N/A'}
                        </span>
                      </div>
                      <div className='coreops-item-details'>
                        <p className='coreops-item-subtitle'>
                          {exp.role || 'N/A'}
                        </p>
                        {exp.duration && exp.duration !== 'N/A' && (
                          <p className='coreops-item-meta'>
                            <FontAwesomeIcon icon={faClock} /> {exp.duration}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <p className='coreops-no-data-text'>
                    No professional experience listed or extracted.
                  </p>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    DEBUG: companiesWorked value ={' '}
                    {JSON.stringify(companiesWorked)}
                  </p>
                </div>
              )}
            </section>

            <section className='coreops-profile-card'>
              <h3 className='coreops-card-title'>
                <FontAwesomeIcon icon={faGraduationCap} /> Education
              </h3>
              {educationList &&
              Array.isArray(educationList) &&
              educationList.length > 0 ? (
                <div className='coreops-experience-list'>
                  {educationList.map((edu, index) => (
                    <div key={index} className='coreops-experience-item'>
                      <div className='coreops-item-header'>
                        <FontAwesomeIcon
                          icon={faGraduationCap}
                          className='coreops-item-icon'
                        />
                        <span className='coreops-item-main-title'>
                          {edu.institution || 'N/A'}
                        </span>
                      </div>
                      <div className='coreops-item-details'>
                        <p className='coreops-item-subtitle'>
                          {edu.degree || 'N/A'}
                        </p>
                        {edu.year && edu.year !== 'N/A' && (
                          <p className='coreops-item-meta'>
                            <FontAwesomeIcon icon={faCalendarAlt} /> {edu.year}
                          </p>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div>
                  <p className='coreops-no-data-text'>
                    No education details listed or extracted.
                  </p>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    DEBUG: educationList value = {JSON.stringify(educationList)}
                  </p>
                </div>
              )}
            </section>

            {/* Rejection Info Card if Rejected */}
            {interviewStatus === 'Rejected' && (
              <section className='coreops-profile-card' style={{ borderLeft: '4px solid #d9534f', backgroundColor: '#fdf2f2' }}>
                <h3 className='coreops-card-title' style={{ color: '#d9534f' }}>
                  <FontAwesomeIcon icon={faBan} /> Rejection Details
                </h3>
                <p style={{ margin: '4px 0', fontSize: '14px' }}>
                  <strong>Stage of Rejection:</strong> {candidate.rejectionStage || 'General'}
                </p>
                {candidate.rejectionReason && (
                  <p style={{ margin: '4px 0', fontSize: '14px' }}>
                    <strong>Internal Reason:</strong> {candidate.rejectionReason}
                  </p>
                )}
                <p style={{ margin: '4px 0', fontSize: '13px', color: '#555' }}>
                  <strong>Email Status:</strong> {candidate.rejectionEmailSent ? `✅ Sent on ${new Date(candidate.rejectionEmailSentAt).toLocaleString()}` : '❌ Not sent via automated mail'}
                </p>
              </section>
            )}

            {/* Interview Notes & Timeline History */}
            {candidate.interviewNotes && candidate.interviewNotes.length > 0 && (
              <section className='coreops-profile-card'>
                <h3 className='coreops-card-title'>
                  <FontAwesomeIcon icon={faClipboardList} /> Interview Timeline & Notes
                </h3>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                  {candidate.interviewNotes.slice().reverse().map((n, i) => (
                    <div key={i} style={{ padding: '10px 14px', borderRadius: '6px', backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span style={{ fontWeight: '600', color: stageColors[n.stage] || '#333', fontSize: '13px' }}>
                          {n.stage}
                        </span>
                        <span style={{ fontSize: '11px', color: '#888' }}>
                          {new Date(n.createdAt).toLocaleString()}
                        </span>
                      </div>
                      <p style={{ margin: 0, fontSize: '13px', color: '#444' }}>{n.note}</p>
                    </div>
                  ))}
                </div>
              </section>
            )}
          </main>
        </div>

        {/* Rejection Modal */}
        <RejectionModal
          show={showRejectionModal}
          candidate={candidate}
          onClose={() => setShowRejectionModal(false)}
          onSuccess={handleRejectionSuccess}
          isQualified={isQualifiedCandidate}
        />
        <footer className='coreops-footer results-sub-footer'>
          <p>
            © {new Date().getFullYear()} CoreOps.ai - Candidate Profile View
          </p>
        </footer>
      </div>
    </div>
  );
}

export default CandidateProfile;
